








import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { WordSearchPuzzle, Cell } from '@/wordsearch/types';

const puzzle = namespace('Puzzle');

@Component
export default class PuzzleWordMark extends Vue {
  @puzzle.State
  private puzzle!: WordSearchPuzzle;

  @puzzle.State
  private gridSize!: number;

  @puzzle.Getter
  private cellWidth!: number;

  @puzzle.Getter
  private cellHeight!: number;

  @Prop() start!: Cell;

  @Prop() end!: Cell;

  @Prop() answer!: boolean;

  get color() {
    return this.answer ? '#ffef5c' : '#087da1';
  }

  get markStyle() {
    const length = Math.sqrt((this.start.x - this.end.x) ** 2 + (this.start.y - this.end.y) ** 2);
    const containerLength = (length + 1) * this.cellWidth;

    const dx = this.end.x - this.start.x;
    const dy = this.end.y - this.start.y;
    const angle = (Math.atan2(dy, dx) * 180) / Math.PI;

    const x = this.start.x * this.cellWidth;
    const y = this.start.y * this.cellHeight;

    return `
      height: ${this.cellHeight - 2}px;
      width: ${containerLength - 2}px;
      border-radius: ${this.cellHeight * 0.5}px;
      transform: translate(${x}px, ${y}px) rotate(${angle}deg);
      transform-origin: ${(this.cellHeight - 2) * 0.5}px center;
    `;
  }
}
